import { makeAutoObservable } from "mobx";
import { RArray } from "../../collections";
import { RDate } from "../../core";
export class OrderingHours {
    constructor(params) {
        this.weeklySchedule = params.weeklySchedule;
        makeAutoObservable(this);
    }
    calculateDates(fromDate, toDate) {
        const dates = [];
        while (fromDate.isBefore(toDate)) {
            dates.push(fromDate);
            fromDate = fromDate.add(30, "minutes");
        }
        return dates;
    }
    fulfillmentDates(date, holidays) {
        const holidaysForDate = holidays.findWhere((holiday) => date.isBetween(holiday.startDate, holiday.endDate));
        let result = [];
        // if there are holidays for the date, we override default ordering hours
        if (holidaysForDate) {
            const fromDate = RDate.fromDateAndTime(date, RDate.fromHourAndMinuteString(holidaysForDate.timeRange.from.toString(), date.tz));
            const toDate = RDate.fromDateAndTime(date, RDate.fromHourAndMinuteString(holidaysForDate.timeRange.to.toString(), date.tz));
            result = this.calculateDates(fromDate, toDate);
        }
        else {
            result = this.weeklySchedule
                .dayOfWeek(date.weekday)
                .timeRanges.map((timeRange) => {
                const fromDate = RDate.fromDateAndTime(date, RDate.fromHourAndMinuteString(timeRange.from.toString(), date.tz));
                const toDate = RDate.fromDateAndTime(date, RDate.fromHourAndMinuteString(timeRange.to.toString(), date.tz));
                return this.calculateDates(fromDate, toDate);
            })
                .flat();
        }
        return new RArray(result).drop(2);
    }
}
